import axios from 'axios'

export default {
  namespaced: true,
  state: {
    brand: {}
  },
  getters:{
    getBranchData: state => {
      return state.brand
    },
  },
  mutations: {
    updateBrand(state, payload) {
      state.brand = payload.brand;
    }
  },
  actions: {
    verifyAdmin({
      commit
    }) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/branch/web/verifyAdmin",
          data: {},
          method: 'PUT'
        }).then(response => {
          commit('updatePartialUser', {
            user: response.data.entity
          }, {
            root: true
          })
          if (response.data.status) {
            resolve(response)
          } else {
            reject(response);
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    getBrand({
      commit
    }) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/brand/web/getbrand",
          method: 'GET'
        }).then(response => {
          commit('updateBrand', {
            brand: response.data.entity
          })
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    updateBranch({
      commit
    }, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/branch/web/update",
          data: obj,
          method: "PUT"
        }).then(response => {
          if (response.data.status) {
            commit("updateBranch", {
              branch: response.data.entity
            }, {
              root: true
            })
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })

      })
    },
    createBranchOB(o, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/branch/web/create/OB",
          data: obj,
          method: "POST"
        }).then(response => {
          if (response.data.status) {
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    updateImageBranch({
      commit
    }) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/branch/web/getlogobyid",
          method: "GET"
        }).then(response => {
          if (response.data.status) {
            const imageStorageDoesExist = response.data.entity.imageStorage !== undefined
            commit("updateImageBranch", {
              image: imageStorageDoesExist? response.data.entity.imageStorage.miniObjUrl : null
            }, {
              root: true
            })
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    changeBranch(o, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/branch/change?id=" + id,
          method: "PUT"
        }).then(response => {
          if (response.data.status) {
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    getSMTPconfig() {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/branch/web/smtp",
          method: "GET"
        }).then(response => {
          if (response) {
            resolve(response);
          }
          reject(response);
        }).catch(error => {
          reject(error);
        })
      });
    },
    testSMTP() {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/branch/web/smtp/test",
          method: "GET"
        }).then(response => {
          if (response) {
            resolve(response);
          }
          reject(response);
        }).catch(error => {
          reject(error);
        })
      });
    },
    createdSMTP(o,obj) {
      return new Promise((resolve, reject) => {
        console.log(obj)
        axios({
          url: process.env.VUE_APP_URL + "/branch/web/smtp",
          method: "PUT",
          data: obj,
        }).then(response => {
          if (response) {
            resolve(response);
          }else{
            reject(response);
          }
        }).catch(error => {
          reject(error);
        })
      });
    },
    deleteEmail() {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/branch/web/smtp",
          method: 'DELETE'
        }).then(response => {
          if (response) {
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    onBoarding({commit}) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/branch/web/onboarding",
          method: 'GET'
        }).then(response => {
          commit('updateBrand', {
            brand: response.data
          })
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    updateBranchOB(o, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/branch/web/onboarding",
          data: obj,
          method: "POST"
        }).then(response => {
          if (response.data.status) {
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
  }
}
